import axios from 'axios';

const staging_dashboard_url = 'staging-dashboard/';
const run_staging_url = 'run-staging/';
const staging_project_url = 'staging-project/';
const snow_project_report_url = 'snow-project-report/';
const staging_log_url = 'staging-log/';
const conflict_url = 'conflict/';
const resolve_conflicts_url = 'resolve-conflicts/';
const advance_staging_url = 'advance-staging/';
const cancel_staging_url = 'cancel-staging/';
const activate_only_url = 'activate-only/';
const new_homeowner_url = "new-homeowner/";

function addSearchFilters(url, filters) {
  console.log(filters);
  if (filters.filter_specific_conflicts !== "" && filters.filter_specific_conflicts !== undefined) {
    url += filters.filter_specific_conflicts;
  }
  if (filters.filter_conflicts !== null && filters.filter_conflicts !== undefined) {
    url += `filter_conflicts=${filters.filter_conflicts}&`;
  }
  if (filters.filter_no_conflicts !== null && filters.filter_no_conflicts !== undefined) {
    url += `filter_no_conflicts=${filters.filter_no_conflicts}&`;
  }
  if (filters.filter_serious_conflicts !== null && filters.filter_serious_conflicts !== undefined) {
    url += `filter_serious_conflicts=${filters.filter_serious_conflicts}&`;
  }
  if (filters.pre_check_required !== null && filters.pre_check_required !== undefined) {
    url += `filter_pre_check_required=${filters.pre_check_required}&`;
  }
  if (filters.is_quickpay !== null && filters.is_quickpay !== undefined) {
    url += `filter_quick_pay=${filters.is_quickpay}&`;
  }
  if (filters.snail_mail_only !== null && filters.snail_mail_only !== undefined) {
    url += `filter_snail_mail_only=${filters.snail_mail_only}&`;
  }
  if (filters.filter_column_one !== null && filters.filter_column_one !== undefined) {
    url += `filter_stage_one=${filters.filter_column_one}&`;
  }
  if (filters.filter_column_two !== null && filters.filter_column_two !== undefined) {
    url += `filter_stage_two=${filters.filter_column_two}&`;
  }
  if (filters.filter_column_three !== null && filters.filter_column_three !== undefined) {
    url += `filter_stage_three=${filters.filter_column_three}&`;
  }
  if (filters.filter_column_four !== null && filters.filter_column_four !== undefined) {
    url += `filter_stage_four=${filters.filter_column_four}&`;
  }
  if (filters.filter_column_five !== null && filters.filter_column_five !== undefined) {
    url += `filter_stage_five=${filters.filter_column_five}&`;
  }
  if (filters.filter_declined !== null && filters.filter_declined !== undefined) {
    url += `filter_declined=${filters.filter_declined}&`;
  }
  if (filters.filter_in_progress !== null && filters.filter_in_progress !== undefined) {
    url += `filter_in_progress=${filters.filter_in_progress}&`;
  }
  if (filters.filter_commercial !== null && filters.filter_commercial !== undefined) {
    url += `filter_commercial=${filters.filter_commercial}&`;
  }
  if (filters.filter_po !== null && filters.filter_po !== undefined) {
    url += `filter_po=${filters.filter_po}&`;
  }
  if (filters.has_meter_pits !== null && filters.has_meter_pits !== undefined) {
    url += `has_meter_pits=${filters.has_meter_pits}&`;
  }
  if (filters.filter_timeline !== null && filters.filter_timeline !== undefined) {
    url += `filter_timeline=${filters.filter_timeline}&`;
  }
  if (filters.search !== null && filters.search !== undefined && filters.search !== '') {
    url += `search=${filters.search}&`;
  }
  if (filters.number_per_page !== null && filters.number_per_page !== undefined) {
    url += `number_per_page=${filters.number_per_page}&`;
  }
  if (filters.filter_overdue) {
    url += `filter_overdue=${filters.filter_overdue}`;
  }
  else {
    url += `number_per_page=${50}&`;
  }

  return url;
}

export default {
  async getDashboard(startup_year, blowdown_year, lawn_maintenance_year, snow_year) {
    const url = staging_dashboard_url +
      `?snow_year=${snow_year}&` +
      `startup_year=${startup_year}&` +
      `blowdown_year=${blowdown_year}&` +
      `lawn_maintenance_year=${lawn_maintenance_year}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async runBlowdown(year, profile_id) {
    const url = run_staging_url + `?is_blowdown=true&year=${year}&user_pk=${profile_id}&`;
    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async runStartup(year, profile_id) {
    const url = run_staging_url + `?is_startup=true&year=${year}&user_pk=${profile_id}&`;
    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async runSnow(year, profile_id) {
    const url = run_staging_url + `?is_snow=true&year=${year}&user_pk=${profile_id}&`;
    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async runLawnMaintenance(year, profile_id) {
    const url = run_staging_url + `?is_lawn_maintenance=true&year=${year}&user_pk=${profile_id}&`;
    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getSnow(year, page, filters) {
    let url = staging_project_url + `?snow=true&year=${year}&page=${page}&`;
    url = addSearchFilters(url, filters);
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getLawnMaintenance(year, page, filters) {
    let url = staging_project_url + `?lawn_maintenance=true&year=${year}&page=${page}&`;
    url = addSearchFilters(url, filters);
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getStartup(year, page, filters) {
    let url = staging_project_url + `?startup=true&year=${year}&page=${page}&`;
    url = addSearchFilters(url, filters);
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getBlowdown(year, page, filters) {
    let url = staging_project_url + `?blowdown=true&year=${year}&page=${page}&`;
    url = addSearchFilters(url, filters);
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async getStagingProject(id) {
    const url = staging_project_url + `${id}`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async createLog(log) {
    return axios.post(staging_log_url, log)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async updateConflict(conflict, id) {
    const url = conflict_url + `${id}/`;
    return axios.patch(url, conflict)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async updateConflicts(staging_project_id, profile_id) {
    let url = `${resolve_conflicts_url}?staging_project_pk=${staging_project_id}&`;

    url += `user_pk=${profile_id}&`;

    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async updateStagingProject(staging_project, id, profile_id) {
    const url = staging_project_url + `${id}/?user_pk=${profile_id}&`;
    return axios.patch(url, staging_project)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.repsonse.data);
      });
  },
  async activateOnlyStagingProject(staging_project, id) {
    const url = `${activate_only_url}?id=${id}`;
    return axios.post(url, staging_project)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async advanceStaging(selected_ids, user_id) {
    let url = advance_staging_url + `?user_pk=${user_id}&`;

    selected_ids.map((id) => {
      url += `staging_project_id=${id}&`;
    });

    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async cancelStaging(id) {
    let url = cancel_staging_url + `?id=${id}&`;

    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async newHomeowner(project_id) {
    let url = new_homeowner_url + `?project=${project_id}&`;

    return axios.post(url, {})
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      })
  },
  async getSnowProjectReport(year, page, numberPerPage) {
    const url = snow_project_report_url + `?year=${year}&page=${page}&number_per_page=${numberPerPage}&`;
    return axios.get(url)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async updateSnowProjectReport(id, patch) {
    const url = snow_project_report_url + `${id}/`;
    return axios.patch(url, patch)
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  },
  async downloadSnowProjectReportCSV(year) {
    const url = snow_project_report_url + `csv/?year=${year}&`;
    return axios.get(url, { responseType: 'blob' })
      .then((response) => {
        return response.data;
      }).catch(err => {
        console.log(err.response.data);
      });
  }
}
